var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
import {
  subscribeToConfig as subscribeToConfig2,
  MODULE_VERSION,
  isConfigSettled
} from "@leagueplatform/config";
import { getEnvironment } from "@leagueplatform/app-environment";

// src/observability.ts
import { isNodeTestEnv } from "@leagueplatform/app-environment";
import { subscribeToConfig } from "@leagueplatform/config";
import { Auth } from "@leagueplatform/auth";
import stringify from "json-stringify-safe";

// src/sentry/sentry.ts
import { useEffect } from "react";
import {
  BrowserClient,
  defaultIntegrations,
  defaultStackParser,
  Hub,
  makeFetchTransport
} from "@sentry/browser";
import * as Sentry from "@sentry/browser";
import { reactRouterV6BrowserTracingIntegration } from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocationLegacy as useLocation,
  useNavigationType
} from "@leagueplatform/routing";

// src/observability.utils.ts
import merge from "lodash.merge";
import { isDev } from "@leagueplatform/app-environment";
import { leagueRoutesMap } from "@leagueplatform/league-routes";
var ENABLE_DEV_FLAG_STRING = "ENABLE_DEV_OBSERVABILITY";
var DISABLED_CLIENT_IDS = ["presenter-app-web"];
var isAppDisabled = (clientId) => clientId ? DISABLED_CLIENT_IDS.includes(clientId) : false;
var combineErrorContexts = (contexts) => contexts.reduce(
  (previousContext, currentContext) => merge(previousContext, currentContext)
);
var isObservabilityEnabled = (clientId) => (!isDev() || sessionStorage.getItem(ENABLE_DEV_FLAG_STRING) === "true") && !isAppDisabled(clientId);
var memoizedGetModuleNameFromUrl = (pathname) => {
  const path = pathname || window.location.pathname;
  let cache;
  return () => {
    if ((cache == null ? void 0 : cache.path) === path)
      return cache.moduleName;
    const moduleName = Object.entries(leagueRoutesMap).filter(([, value]) => path.includes(String(value))).reduce(
      (longestValue, [key, value]) => value.length > longestValue[1].length ? [key, value] : longestValue,
      ["", ""]
    )[0];
    cache = { moduleName, path };
    return moduleName;
  };
};
var getModuleNameFromUrl = (pathname) => memoizedGetModuleNameFromUrl(pathname);
function getDomain(pathname) {
  const moduleName = getModuleNameFromUrl(pathname)();
  const domains = {
    "about-me": ["about-me"],
    "care-landing": ["care-collections", "care-discovery", "care-documents"],
    claims: ["wallet", "claims"],
    home: ["home"],
    journey: [
      "health-journey",
      "health-journey-history",
      "health-need-pages",
      "health-programs",
      "health-progress"
    ],
    "live-chat": ["messaging", "live-chat"],
    // Not part of the Web SDK, but we still want to track it (for now)
    "support-experience": ["customer-support"]
  };
  if (moduleName === "" || !moduleName) {
    return "uncategorized";
  }
  const domainKey = Object.keys(domains).find(
    (key) => domains[key].includes(moduleName)
  );
  return domainKey != null ? domainKey : moduleName;
}
var getDefaultConfigValues = () => ({
  dsn: "https://fcb8e7e793e149acacb6ac0ad1546855@o4504039554088960.ingest.sentry.io/4504243159433216",
  enabled: true,
  maxBreadcrumbs: 100,
  errorsSampleRate: 1,
  tracesSampleRate: 0.01,
  integrateWithLeagueRouting: true
});

// src/sentry/sentry.utils.ts
var EVENT_IGNORE_CRITERIA = [
  "<unknown>",
  "ChunkLoadError",
  /WebSocket closed with reason: \(1006\)/
];
var setSentryContext = (errorContext, scope) => {
  var _a, _b, _c;
  if (errorContext.tags)
    scope.setTags(errorContext.tags);
  if (errorContext.ownershipTeam || ((_a = errorContext.tags) == null ? void 0 : _a.moduleName))
    scope.setTag(
      "ownershipTeam",
      (_c = errorContext.ownershipTeam) != null ? _c : (_b = errorContext.tags) == null ? void 0 : _b.moduleName
    );
  if (errorContext.context) {
    Object.entries(errorContext.context).forEach(
      (contextData) => {
        scope.setContext(contextData[0], contextData[1]);
      }
    );
  }
  return scope;
};

// src/sentry/sentry.ts
var DEFAULT_SAMPLE_RATE = 1;
var leagueSDKSentryHub;
var isInitialized = (targetHub = leagueSDKSentryHub) => {
  if (targetHub)
    return true;
  if (isObservabilityEnabled()) {
    const targetHubType = targetHub === leagueSDKSentryHub ? "League SDK" : "APP";
    console.warn(
      `Observability - ${targetHubType} instance of Sentry has not been initialized.`
    );
  }
  return false;
};
var startCustomTransaction = (transactionContext) => {
  if (!isInitialized())
    return null;
  return leagueSDKSentryHub.startTransaction(transactionContext);
};
var getActiveTransaction = () => {
  var _a, _b;
  return (_b = (_a = Sentry.getCurrentHub()) == null ? void 0 : _a.getScope()) == null ? void 0 : _b.getTransaction();
};
var initHub = (metadata, config) => {
  const client = new BrowserClient({
    dsn: config.dsn,
    environment: config.environment,
    transport: makeFetchTransport,
    stackParser: defaultStackParser,
    integrations: [
      ...defaultIntegrations.filter(
        (integration) => integration.name !== "Dedupe"
      ),
      new Sentry.Integrations.GlobalHandlers({
        onerror: false,
        onunhandledrejection: false
      })
    ],
    sampleRate: config.errorsSampleRate || DEFAULT_SAMPLE_RATE,
    tracesSampleRate: config.tracesSampleRate,
    ignoreErrors: EVENT_IGNORE_CRITERIA,
    beforeSend(event) {
      event.tags = __spreadProps(__spreadValues({}, event.tags), { domain: getDomain() });
      return event;
    }
  });
  leagueSDKSentryHub = new Hub(client);
  leagueSDKSentryHub.setTags(__spreadProps(__spreadValues({}, metadata), { originHub: "SDK" }));
};
var initSDK = (config) => {
  Sentry.init({
    dsn: config.dsn,
    integrations: [
      reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      })
    ],
    environment: config.environment,
    tracesSampleRate: config.tracesSampleRate,
    sampleRate: config.errorsSampleRate || DEFAULT_SAMPLE_RATE,
    ignoreErrors: EVENT_IGNORE_CRITERIA,
    // Called for transaction events
    beforeSendTransaction(event) {
      const allowedTransactionTypes = ["url", "route"];
      if (event.transaction && event.transaction_info && allowedTransactionTypes.includes(event.transaction_info.source)) {
        event.tags = __spreadProps(__spreadValues({}, event.tags), { domain: getDomain(event.transaction) });
      }
      return event;
    },
    beforeSend(event) {
      event.tags = __spreadProps(__spreadValues({}, event.tags), { domain: getDomain() });
      return event;
    }
  });
  Sentry.setTags({ originHub: "APP" });
};
var captureError = (error, options) => {
  var _a, _b, _c, _d, _e, _f;
  const capturedError = error;
  if ((_a = options == null ? void 0 : options.context) == null ? void 0 : _a.errorName)
    capturedError.name = (_b = options == null ? void 0 : options.context) == null ? void 0 : _b.errorName;
  if ((_d = (_c = options == null ? void 0 : options.context) == null ? void 0 : _c.tags) == null ? void 0 : _d.moduleName)
    capturedError.name = `${String((_f = (_e = options == null ? void 0 : options.context) == null ? void 0 : _e.tags) == null ? void 0 : _f.moduleName)} - ${capturedError.name}`;
  const targetHub = (options == null ? void 0 : options.targetHub) === "APP" /* APP */ ? Sentry.getCurrentHub() : leagueSDKSentryHub;
  if (isInitialized(targetHub)) {
    const globalBreadcrumbs = Sentry.getCurrentScope()["_breadcrumbs"];
    targetHub.run((currentHub) => {
      currentHub.withScope((scope) => {
        if (globalBreadcrumbs == null ? void 0 : globalBreadcrumbs.length)
          globalBreadcrumbs.forEach(
            (breadcrumb) => scope.addBreadcrumb(breadcrumb)
          );
        if (options == null ? void 0 : options.context)
          setSentryContext(options == null ? void 0 : options.context, scope);
        currentHub.captureException(capturedError);
      });
    });
  }
};
var captureMessage = (message, options) => {
  const targetHub = (options == null ? void 0 : options.targetHub) === "APP" /* APP */ ? Sentry.getCurrentHub() : leagueSDKSentryHub;
  if (isInitialized(targetHub))
    targetHub.run((currentHub) => {
      currentHub.withScope((scope) => {
        var _a;
        if (options == null ? void 0 : options.context)
          setSentryContext(options == null ? void 0 : options.context, scope);
        currentHub.captureMessage(message, (_a = options == null ? void 0 : options.context) == null ? void 0 : _a.severityLevel);
      });
    });
};
var setUserId = (userId) => {
  if (isInitialized()) {
    leagueSDKSentryHub.setUser({ id: userId != null ? userId : "" });
    Sentry.getCurrentHub().setUser({ id: userId != null ? userId : "" });
  }
};
var setGlobalContext = (key, context) => {
  if (isInitialized()) {
    leagueSDKSentryHub.setContext(key, context);
    Sentry.getCurrentHub().setContext(key, context);
  }
};
function addBreadcrumb2(breadcrumb) {
  Sentry.addBreadcrumb(breadcrumb);
}
var sentry_default = {
  initHub,
  initSDK,
  captureError,
  captureMessage,
  startCustomTransaction,
  getActiveTransaction,
  setUserId
};

// src/observability.ts
var eventsQueue = { errors: [], messages: [] };
var configSubscription;
function updateConfigContext() {
  if (typeof configSubscription !== "undefined")
    return;
  configSubscription = subscribeToConfig(
    ({ config }) => {
      const _a = config, { core } = _a, restOfConfig = __objRest(_a, ["core"]);
      const _b = core, { ui, i18n } = _b, restOfCore = __objRest(_b, ["ui", "i18n"]);
      const simplifiedConfig = __spreadValues({
        core: restOfCore
      }, restOfConfig);
      return Object.fromEntries(
        Object.entries(simplifiedConfig).map(([key, value]) => [
          key,
          stringify(value)
        ])
      );
    },
    (selection) => {
      if (!selection)
        return;
      setGlobalContext("Config", selection);
    }
  );
}
var captureQueuedEvents = () => {
  eventsQueue.errors.forEach((queuedError) => {
    sentry_default.captureError(queuedError.error, {
      context: __spreadValues({}, queuedError.context),
      targetHub: queuedError.targetHub
    });
  });
  eventsQueue.errors = [];
  eventsQueue.messages.forEach((queuedMessage) => {
    sentry_default.captureMessage(queuedMessage.message, {
      context: __spreadValues({}, queuedMessage.context),
      targetHub: queuedMessage.targetHub
    });
  });
  eventsQueue.messages = [];
};
var startTransaction = (transactionContext) => sentry_default.startCustomTransaction(transactionContext);
var finishTransaction = (transaction) => {
  transaction == null ? void 0 : transaction.finish();
};
var startSpan = (transaction, spanContext) => transaction == null ? void 0 : transaction.startChild(spanContext);
var startSpanOnActiveTransaction = (spanContext) => {
  const activeTransaction = sentry_default.getActiveTransaction();
  return activeTransaction == null ? void 0 : activeTransaction.startChild(spanContext);
};
var finishSpan = (span) => {
  span.finish();
};
var activeInitializations = /* @__PURE__ */ new Set();
var initializationSymbol = Symbol("o11y initialization");
if (!isNodeTestEnv)
  activeInitializations.add(initializationSymbol);
var initObservability = (_0) => __async(void 0, [_0], function* ({
  metadata,
  config,
  isAppSentryConfig
}) {
  activeInitializations.add(initializationSymbol);
  if (isObservabilityEnabled(metadata.clientId)) {
    if (!config.enabled) {
      activeInitializations.delete(initializationSymbol);
      return;
    }
    sentry_default.initHub(metadata, __spreadValues({}, config));
    if (isAppSentryConfig)
      sentry_default.initSDK(__spreadValues({}, config));
    activeInitializations.delete(initializationSymbol);
    captureQueuedEvents();
    updateConfigContext();
  }
});
var captureSentryError = (error, targetHub, context) => __async(void 0, null, function* () {
  if (Auth.initialized) {
    try {
      const userId = yield Auth.getUserId();
      sentry_default.setUserId(userId);
    } catch (ex) {
    }
  }
  const moduleName = targetHub === "SDK" /* SDK */ ? getModuleNameFromUrl()() : "";
  if (activeInitializations.size) {
    eventsQueue.errors.push({
      error,
      context: __spreadProps(__spreadValues({}, context), { tags: __spreadProps(__spreadValues({}, context == null ? void 0 : context.tags), { moduleName }) }),
      targetHub
    });
  } else {
    sentry_default.captureError(error, {
      context: __spreadProps(__spreadValues({}, context), { tags: __spreadProps(__spreadValues({}, context == null ? void 0 : context.tags), { moduleName }) }),
      targetHub
    });
  }
});
var captureSentryMessage = (message, targetHub, context) => __async(void 0, null, function* () {
  if (Auth.initialized) {
    try {
      const userId = yield Auth.getUserId();
      sentry_default.setUserId(userId);
    } catch (ex) {
    }
  }
  const moduleName = targetHub === "SDK" /* SDK */ ? getModuleNameFromUrl()() : void 0;
  if (activeInitializations.size) {
    eventsQueue.messages.push({
      message,
      context: __spreadProps(__spreadValues({}, context), { tags: __spreadProps(__spreadValues({}, context == null ? void 0 : context.tags), { moduleName }) }),
      targetHub
    });
  } else {
    sentry_default.captureMessage(message, {
      context: __spreadProps(__spreadValues({}, context), { tags: __spreadProps(__spreadValues({}, context == null ? void 0 : context.tags), { moduleName }) }),
      targetHub
    });
  }
});
var captureError2 = (error, context) => __async(void 0, null, function* () {
  if (!isNodeTestEnv()) {
    yield captureSentryError(error, "SDK" /* SDK */, context);
  }
});
var captureMessage2 = (message, context) => __async(void 0, null, function* () {
  if (!isNodeTestEnv()) {
    yield captureSentryMessage(message, "SDK" /* SDK */, context);
  }
});
var captureAppError = (error, context) => __async(void 0, null, function* () {
  if (!isNodeTestEnv()) {
    yield captureSentryError(error, "APP" /* APP */, context);
  }
});
var captureAppMessage = (message, context) => __async(void 0, null, function* () {
  if (!isNodeTestEnv()) {
    yield captureSentryMessage(message, "APP" /* APP */, context);
  }
});

// src/components/error-boundary.component.tsx
import * as React from "react";
var ObservabilityErrorBoundary = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  componentDidCatch(error, errorInfo) {
    const err = new Error(error);
    err.stack = error.stack;
    const { errorContext, onError } = this.props;
    captureError2(
      err,
      combineErrorContexts([
        {
          errorName: `Error Boundary: UI Error - ${err.message}`,
          context: { "Error Boundary Error Info": errorInfo }
        },
        errorContext || {}
      ])
    );
    if (onError)
      onError(err);
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    const { children, fallback } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return fallback || null;
    }
    return children;
  }
};

// src/index.ts
subscribeToConfig2(
  (configWithStatus) => {
    var _a;
    if (!isConfigSettled(configWithStatus))
      return void 0;
    const { config } = configWithStatus;
    return {
      clientId: config.core.clientId,
      apiUrl: config.core.api.url,
      isUsingLeagueRouting: (_a = config.core.routing) == null ? void 0 : _a.isUsingLeagueRouting,
      dsn: config["config_observability_sentry-dsn"],
      maxBreadcrumbs: config["config_observability_sentry-max-breadcrumbs"],
      errorsSampleRate: config["config_observability_sentry-errors-sample-rate"],
      tracesSampleRate: config["config_observability_sentry-traces-sample-rate"],
      customViewTracing: config["config_observability_custom-view-tracing"],
      enabled: config.config_observability_enabled
    };
  },
  (selection) => {
    if (!selection)
      return;
    let isAppSentryConfig = false;
    let observabilityConfig = __spreadValues({
      environment: getEnvironment()
    }, getDefaultConfigValues());
    if (selection.dsn) {
      isAppSentryConfig = true;
      observabilityConfig = {
        environment: getEnvironment(),
        dsn: selection.dsn,
        enabled: selection.enabled || true,
        maxBreadcrumbs: selection.maxBreadcrumbs,
        errorsSampleRate: selection.errorsSampleRate,
        tracesSampleRate: selection.tracesSampleRate,
        integrateWithLeagueRouting: selection.isUsingLeagueRouting
      };
    }
    initObservability({
      metadata: {
        /**
         * TODO: come up with more robust "current SDK version" importable. Right now,
         * each individual module has access to its own version only. Thankfully
         * our external modules are versioned monolithically, so importing the
         * `config` module's version IS an accurate way to convey the current
         * monolithic version in the Sentry metadata, but this is brittle.
         */
        moduleVersion: MODULE_VERSION,
        clientId: selection.clientId
      },
      config: observabilityConfig,
      isAppSentryConfig
    });
  }
);
export {
  ObservabilityErrorBoundary,
  addBreadcrumb2 as addBreadcrumb,
  captureAppError,
  captureAppMessage,
  captureError2 as captureError,
  captureMessage2 as captureMessage,
  combineErrorContexts,
  finishSpan,
  finishTransaction,
  startSpan,
  startSpanOnActiveTransaction,
  startTransaction
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/observability'] = window.leagueSDKsPresent['@leagueplatform/observability'] || [];
    window.leagueSDKsPresent['@leagueplatform/observability'].push('2.22.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/observability'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/observability module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map